import React from 'react';

import { Accordion, AccordionProps, useMantineTheme } from '@mantine/core';

interface DroxyAccordionProps extends AccordionProps {
  children: React.ReactNode;
  defaultOpenSections?: string[];
}

export function DroxyAccordion({ children, defaultOpenSections, ...accordionProps }: DroxyAccordionProps) {
  const theme = useMantineTheme();

  return (
    <Accordion
      multiple
      defaultValue={defaultOpenSections}
      transitionDuration={0}
      styles={{
        item: {
          border: `1px solid ${theme.colors.gray[2]}`,
          marginBottom: theme.spacing.md,
          borderRadius: theme.radius.md,
          overflow: 'hidden',
          backgroundColor: theme.white,
          boxShadow: 'none'
        },
        control: {
          padding: `6px ${theme.spacing.md}`,
          minHeight: 'auto',
          borderBottom: 'none',
          '&:hover': {
            backgroundColor: theme.colors.gray[0]
          },
          '&[data-active]': {
            borderBottom: `1px solid ${theme.colors.gray[2]}`
          }
        },
        panel: {
          padding: `${theme.spacing.sm} ${theme.spacing.md} ${theme.spacing.md} ${theme.spacing.md}`
        }
      }}
      {...accordionProps}>
      {children}
    </Accordion>
  );
}
